import { render } from "./Left1.vue?vue&type=template&id=1d583208&scoped=true"
import script from "./Left1.vue?vue&type=script&lang=js"
export * from "./Left1.vue?vue&type=script&lang=js"

import "./Left1.vue?vue&type=style&index=0&id=1d583208&scoped=true&lang=css"

import exportComponent from "D:\\zhwf\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d583208"]])

export default __exports__